import { useTheme } from "@mui/material";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";

export const useFlatRowValueColor = (disabled = false): string => {
	const { palette } = useTheme();
	const hasGoalsRight = useGoalsRightOptional();

	if (disabled) {
		return palette.grey[400];
	}

	return hasGoalsRight ? palette.grey[900] : palette.blue[600];
};
